// Copyright (c) 2016 Deere & Company

import './user-settings.scss';
import React, {PropTypes} from 'react';
import UserSettingsNavigationList from './user-settings-navigation-list';
import WarrantyLoadingIndicator from '../../../../shared/components/warranty-loading-indicator';

const UserSettings = props =>
    <section className='user-settings'>
        <WarrantyLoadingIndicator isLoading={props.busyCounter > 0}/>
        <div className='user-settings-navigation'>
            <UserSettingsNavigationList routes={props.route.childRoutes}/>
        </div>
        <div className='user-settings-panel'>
            {props.children}
        </div>
    </section>;

UserSettings.displayName = 'UserSettings';
UserSettings.propTypes = {
    busyCounter: PropTypes.number.isRequired,
    children: PropTypes.node,
    route: PropTypes.object.isRequired
};

export default UserSettings;



// WEBPACK FOOTER //
// ./src/user/shared/components/user-settings/user-settings.js